module.exports = __webpack_public_path__ + "static/media/choithramsChickenMeatBallsS.e83c283f.png";